import "core-js/modules/es.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/yujian_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "addRechargeConfig",
  data: function data() {
    return {
      form: {
        id: "",
        language: "",
        show_img: "",
        url: "",
        name: "",
        status: 1
      },
      dialogShow: false,
      fileList: [],
      rules: {
        url: [{
          required: true,
          message: "请输入跳转路径",
          trigger: "blur"
        }],
        language: [{
          required: true,
          message: "请选择语言",
          trigger: "blur"
        }],
        show_img: [{
          required: true,
          message: "请上传图片",
          trigger: "blur"
        }]
      }
    };
  },
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (data) {
                  _this.form = {
                    id: data.id,
                    language: data.language,
                    show_img: data.show_img,
                    url: data.url,
                    status: data.status,
                    name: data.name
                  };
                  _this.fileList = [data.show_img];
                }

                _this.dialogShow = true;

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    imgChange: function imgChange(e) {
      this.fileList = e;
      this.form.show_img = e[0] && e[0].response ? e[0].response.data : '';
    },
    urlChange: function urlChange(e) {},
    clearData: function clearData() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.form = {
        id: type ? this.form.id : "",
        language: "",
        status: 1,
        show_img: "",
        url: "",
        name: ""
      };
      this.fileList = [];
      this.$refs.ruleForm.resetFields();
    },
    hide: function hide() {
      this.dialogShow = false;
    },
    submitData: function submitData() {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var reqFn = _this2.form.id ? 'rechargeWebsiteConfigUpdate' : 'rechargeWebsiteConfigAdd';

          _this2.$api[reqFn](_this2.form).then(function (res) {
            if (res.code == 0) {
              _this2.$message({
                message: '操作成功',
                type: 'success'
              });

              _this2.hide();

              _this2.$emit('change');
            }
          });
        }
      });
    }
  }
};